resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/**
 * TimeUtils class
 */
function TimeUtils () {
  this.nowDateObj = new Date();
  /**
     * @desc calculates time at destination
     * @param int offset the Timezone offset
     * @return dateObject of destination
     */

  this.getDestinationTime = function (offset) {
    var utcDate = this.nowDateObj.getTime() + this.nowDateObj.getTimezoneOffset() * 60000,
      destinationDate = new Date(utcDate - 60000 * offset);
    return destinationDate;
  };
  /**
     * @desc calculates if it is DST - In most of Canada DST begins at 2:00 a.m. local time on the second Sunday in March. On the first Sun in Nov areas on DST return to Standard Time at 2:00 a.m. local time. When DST begins turn your clocks ahead one hour.
     * @param a date object the nowDate
     * @return bool - true - YES it is DST
     *                  or
     *                false - NO is not DST
     *
     *      **NOTE this function will not be accurate for a few hours 2 nights a year when the clock changes
     */
  this.isItDST = function (date) {
    if (!date) date = this.nowDateObj;
    var theMonth = date.getMonth(),
      theDate = date.getDate(),
      theDayOfWeek = date.getDay(),
      theHour = date.getHours(),
      theMinute = date.getMinutes();
    // if we are March need to check if after or before 2nd Sunday
    if (theMonth == 2) {
      // March
      if (theDayOfWeek == 0) {
        // it is Sunday
        if (theDate < 8) {
          // it is first Sunday
          return false; // still standard time
        }
        if (theDate > 7 && theDate < 14) {
          // second Sunday
          if (theHour > 2) {
            return true; // after clock change
          } else {
            return false; // before clock change
          }
        } else {
          // past second Sunday we are in DST
          return true;
        }
      }
    }
    // if we are November need to check after or before first Sunday
    if (theMonth == 10) {
      // November
      if (theDayOfWeek == 0) {
        // it is Sunday
        if (theDate < 8) {
          // it is first Sunday
          if (theHour > 2) {
            return false; // after clock change
          } else {
            return true; // before clock change
          }
        } else {
          // past first Sunday we are in ST
          return false;
        }
      }
    }
    // if is now 11-> Dec  or we are before 2-> March it is standard time
    if (theMonth == 11 || theMonth < 2) {
      return false;
    }
    // after 2->March before 10-> Nov it is DST
    if (theMonth > 2 && theMonth < 10) {
      return true;
    }
  };
}
